export default __webpack_public_path__ + "static/media/open.ecd79ab4.svg";